module.exports = __webpack_public_path__ + "0ff7a0c10faa4b287f7ba2b59e4aa5b3.svg";